import { Github } from 'lucide-react'
import { supabase } from '@/lib/supabase/client'

export function OAuthButtons() {
  const handleGitHub = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'github',
      options: { redirectTo: `${import.meta.env.VITE_APP_URL}/auth/callback` },
    })
  }

  const handleGoogle = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${import.meta.env.VITE_APP_URL}/auth/callback` },
    })
  }

  return (
    <div className="flex flex-col gap-3 w-full">
      <button
        onClick={handleGitHub}
        className="flex items-center justify-center gap-2 w-full py-2.5 px-4 bg-gray-800 hover:bg-gray-700 rounded-lg text-white transition-colors"
      >
        <Github size={18} />
        Continue with GitHub
      </button>
      <button
        onClick={handleGoogle}
        className="flex items-center justify-center gap-2 w-full py-2.5 px-4 bg-white hover:bg-gray-100 rounded-lg text-gray-900 transition-colors font-medium"
      >
        Continue with Google
      </button>
    </div>
  )
}
